import React from 'react';
import PropTypes from 'prop-types';
import { InfoWindow } from '@react-google-maps/api';
import $ from 'jquery';

import StationPropType from '../../../../utils/prop-types/station';
import StationMapInfoBox from '../../../maps/station-profile/station-map-info-box';
import { COLORS } from '../../../../styles/variables';
import styles from './styles.css';

export default function StationMapPin({ headerColor, station, title }) {
  const [closeButtonHidden, setCloseButtonHidden] = React.useState(false);
  React.useEffect(() => {
    hideCloseButton();
  }, []);

  // Google Map's InfoWindow has a "close" button, but no way to hide/remove through props. We'll use jQuery to find the button
  const hideCloseButton = () => {
    if (!closeButtonHidden) {
      const closeButton = findCloseButton();
      if (closeButton.length) {
        closeButton.hide();
        $('.gm-style-iw.gm-style-iw-c').css('padding', '0px');
        $('.gm-style-iw .gm-style-iw-d').css('display', 'contents');
        setCloseButtonHidden(true);
      } else {
        window.setTimeout(hideCloseButton, 250);
      }
    }
  };

  const findCloseButton = () => $('.gm-style-iw .gm-ui-hover-effect');

  const position = { lat: station.latitude, lng: station.longitude };

  return (
    <InfoWindow
      position={position}
      lat={position.lat}
      lng={position.lng}
      options={{
        minWidth: 80,
        boxStyle: {
          background: 'red',
        },
      }}
      boxClass={styles.stationPinContainer}
    >
      <StationMapInfoBox
        station={station}
        title={title}
        position={position}
        logoSize="sm"
        headerColor={headerColor}
      />
    </InfoWindow>
  );
}

StationMapPin.propTypes = {
  headerColor: PropTypes.string,
  station: StationPropType.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
};

StationMapPin.defaultProps = {
  headerColor: COLORS.tealGreen,
};
